import { apiUrl } from "../components/ApiManager/AxiosHeaders";

const isFinanceCategory = (category) =>
  category === "finance" || category === "financial";

const toDocumentApiCategory = (category) =>
  isFinanceCategory(category) ? "finance" : "general";

const toFinancialFlag = (category) => (isFinanceCategory(category) ? 1 : 0);

export const recategorizeClientDocument = async ({
  clientId,
  documentId,
  category,
  appId,
  appType,
}) => {
  const apiCategory = toDocumentApiCategory(category);

  const payload = {
    client_id: clientId,
    document_id: documentId,
    category: apiCategory,
    is_financial: toFinancialFlag(apiCategory),
  };

  if (appId != null && appId !== "") {
    payload.app_id = appId;
    payload.appid = appId;
  }
  if (appType) {
    payload.app_type = appType;
    payload.apptype = appType;
  }

  const response = await apiUrl.post("recategorize-client-document", payload);

  if (!response?.data?.status) {
    throw new Error(response?.data?.message || "Failed to recategorize document.");
  }

  return response.data;
};

export const getItemRecordId = (item) =>
  item?.id ?? item?.noteid ?? item?.note_id ?? item?.document_id ?? null;

/** finalNoteType 10 = financial note, 0 (or other) = general */
export const getNoteFinalNoteType = (note) => {
  const raw =
    note?.finalNoteType ??
    note?.finalnotetype ??
    note?.final_note_type ??
    null;

  if (raw != null && raw !== "") {
    return Number(raw) === 10 ? 10 : 0;
  }

  const typeVal = note?.type;
  if (typeVal === 10 || typeVal === "10") return 10;

  return 0;
};

export const isFinanceNote = (note) => getNoteFinalNoteType(note) === 10;

export const resolveNoteTabKey = (category) =>
  category === "financial" || category === "finance" ? "financial" : "general";

export const filterNotesForCategory = (notes, category) => {
  const list = Array.isArray(notes) ? notes : [];
  if (isFinanceCategory(category)) {
    return list.filter(isFinanceNote);
  }
  return list.filter((note) => !isFinanceNote(note));
};

export const getNotesForCategory = (allNotes, financeNotes, category) => {
  if (!isFinanceCategory(category)) {
    return filterNotesForCategory(allNotes, "general");
  }

  const fromFinanceApi = filterNotesForCategory(financeNotes, "financial");
  const fromAllNotes = filterNotesForCategory(allNotes, "financial");
  const byId = new Map();

  [...fromFinanceApi, ...fromAllNotes].forEach((note) => {
    const noteId = getItemRecordId(note);
    if (noteId != null) {
      byId.set(String(noteId), note);
    }
  });

  return Array.from(byId.values());
};

const toNoteApiCategory = (category) =>
  category === "financial" || category === "finance" ? "finance" : "general";

export const recategorizeClientNote = async ({
  clientId,
  noteId,
  note,
  currentCategory,
  category,
  appId,
  appType,
}) => {
  const hasStoredType =
    note?.finalNoteType != null ||
    note?.finalnotetype != null ||
    note?.final_note_type != null;

  const currentType = hasStoredType
    ? getNoteFinalNoteType(note)
    : isFinanceCategory(currentCategory)
      ? 10
      : 0;

  const payload = {
    note_id: noteId,
    client_id: clientId,
    type: currentType,
    category: toNoteApiCategory(category),
  };

  if (appId != null && appId !== "") {
    payload.app_id = appId;
    payload.appid = appId;
  }
  if (appType != null && appType !== "") {
    payload.app_type = appType;
    payload.apptype = appType;
  }

  const response = await apiUrl.post("recategorize-client-note", payload);

  if (!response?.data?.status) {
    throw new Error(response?.data?.message || "Failed to recategorize note.");
  }

  return response.data;
};

export const bulkRecategorizeClientNotes = async ({
  notes = [],
  clientId,
  currentCategory,
  category,
  appId,
  appType,
}) => {
  const moved = [];

  for (const note of notes) {
    const noteId = getItemRecordId(note);
    if (!noteId) continue;

    const result = await recategorizeClientNote({
      clientId,
      noteId,
      note,
      currentCategory,
      category,
      appId,
      appType,
    });
    moved.push(result);
  }

  return moved;
};
